<template>
  <div>
    <v-dialog
      :value="detailTicket"
      max-width="500"
    >
      <ticket-detail :ticket=detailTicket :key=detailTicket.id></ticket-detail>
    </v-dialog>
    <v-card>
      <v-progress-linear
          :value=ticketStats().percentage
          color="green"
          absolute
          height="7"
      ></v-progress-linear>
    <v-card-title>
      Tickets
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Search name"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-subtitle>
      {{ ticketStats().checkin_count }} of {{ ticketStats().count }} checked in.
    </v-card-subtitle>
    <v-data-table
      :headers="headers"
      :items="tickets"
      :search="search"
      :fixed-header=true
      :mobile-breakpoint=10
      :disable-pagination=true
      :hide-default-footer=true
    >
    <template v-slot:item.uid="{ item }">
      <v-chip v-if="item.is_checked_in"
        @click="viewTicketDetails(item)"
        class="ma-2"
        color="green"
        small
        label
        text-color="white"
      >
        {{ item.uid }}
        <v-icon small v-if="item.allergy" color="red lighten-1" right>mdi-alert</v-icon>
      </v-chip>
      <v-chip v-else
          @click="viewTicketDetails(item)"
        class="ma-2"
        color="grey"
        small
        label
        text-color="white"
      >
        {{ item.uid }}
        <v-icon small v-if="item.allergy" color="red lighten-1" right>mdi-alert</v-icon>
      </v-chip>
    </template>
    <template v-slot:item.full_name="{ item }">
      <small>{{ item.full_name }}</small> <br>
    </template>
    <template v-slot:item.phone_number="{ item }">
      <small>{{ item.phone_number }}</small> <br>
    </template>
    </v-data-table>
  </v-card>
  </div>
</template>

<script>
import TicketDetail from '@/components/TicketDetail';
import {mapState} from 'vuex';
import Pusher from 'pusher-js'

export default {
  components: {
    TicketDetail
  },
  data () {
    return {
      detailTicket: false,
        search: '',
        headers: [
        {
          text: 'Ticket',
          align: 'left',
          sortable: true,
          value: 'uid',
        },
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'full_name',
        },
        {
          text: 'Phone',
          align: 'left',
          sortable: true,
          value: 'phone_number',
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadTickets');
  },
  created() {
    this.subscribe()
  },
  methods: {
    subscribe () {
      let pusher = new Pusher('7cec052263633b0073ef', { cluster: 'eu' })
      pusher.subscribe('tickets')
      pusher.bind('update', data => {
        this.$store.commit('UPDATE_TICKET', JSON.parse(data.ticketData))
      })
    },
    viewTicketDetails (item) {
      this.detailTicket = item;
    },
    ticketColor(ticket) {
      if(ticket.is_checked_in){
        return 'green'
      }
    },
    ticketStats() {
      var tickets = this.tickets
      var checkedIn = 0;
      tickets.forEach(ticket => {
        if(ticket.check_in){
          checkedIn++
        }
      })
      return {
        count: tickets.length,
        checkin_count: checkedIn,
        percentage: (checkedIn * 100) / tickets.length,
      }
    }
  },
  computed: {
    ...mapState([
      'tickets'
    ]),
    sortedOrders() {
      // return this.orders
      // console.log('aap')
      return this._.orderBy(this.orders, 'first_name', 'asc');
    }
  }
}

</script>